export default __webpack_public_path__ + "images/drt_c33d9d.svg";